// /agents — real route. Mirrors apps/web's app/agents/page.tsx: a thin
// server shell (dev-bypass-aware guard + <title>) whose entire UI lives in
// the pure-client AgentsClient (app/agents/client.tsx) — plain-fetch data,
// no server-side work at mount, so it alias-mounts unmodified. The guard
// moves to the `_authed` layout route (routes/guards.tsx) instead of an
// inline redirect. Registered into the agents group (G2) from
// routes/agents.tsx.
import { createRoute } from '@tanstack/react-router';
import { AgentsClient } from '@/app/agents/client';
import { authedRoute } from './guards';

export const agentsPageRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/agents',
  component: AgentsClient,
});
